import React, { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import Form from '../form/Form'
import View from '../form/View'
import Header from '../form/Header'
import InputField from '../form/InputField'
import Footer from '../form/Footer'

const useStyles = createUseStyles(theme => ({
  root: {
    height: '100%',
    flexDirection: 'column',
    flex: 1
  },
  content: {
    flex: 1,
    alignItems: 'flex-start',
    margin: '0 36px'
  }
}))

function IdentificationStep (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ value, setValue ] = useState(props.initialData ? props.initialData.value : '')
  const [ documentType, setDocumentType ] = useState(props.initialData && props.initialData.documentType ? props.initialData.documentType : props.documentTypes[0])
  const [ error, setError ] = useState(null)

  const maskCPF = (e) => {
    const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/)
    let value = ''
    if (x[4]) {
        value = `${x[1]}.${x[2]}.${x[3]}-${x[4]}`
    } else if (x[3]) {
        value = `${x[1]}.${x[2]}.${x[3]}`
    } else if (x[2]) {
        value = `${x[1]}.${x[2]}`
    } else {
        value = x[1]
    }
    e.target.value = value
  }

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g,'')
    if(cpf === '') return false
    // Elimina CPFs invalidos conhecidos
    if (cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999")
        return false
    // Valida 1o digito
    let add = 0
    for (let i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i)
    let rev = 11 - (add % 11)
    if (rev === 10 || rev === 11)
        rev = 0
    if (rev !== parseInt(cpf.charAt(9)))
        return false
    // Valida 2o digito
    add = 0
    for (let i = 0; i < 10; i ++)
        add += parseInt(cpf.charAt(i)) * (11 - i)
    rev = 11 - (add % 11)
    if (rev === 10 || rev === 11)
        rev = 0
    if (rev !== parseInt(cpf.charAt(10)))
        return false
    return true
  }

  const applyMask = (evt) => {
    switch (documentType) {
      case 'CPF' : 
        maskCPF(evt)
        break
      default:
    }
    setValue(evt.target.value)
  }

  const onDocumentTypeChange = (evt) => {
    const selectedIndex = evt.target.selectedIndex
    setDocumentType(props.documentTypes[selectedIndex])
  }

  const submitForm = () => {
    let isValid = true
    switch (documentType) {
      case 'CPF' : 
        isValid = validateCPF(value)
        break
      default:
    }
    if (isValid) {
      props.next({ documentType, value })
    } else {
      setError("O valor informado não é válido ou está incompleto")
    }
  }

  const handleEnterKey = () => {
    //document.activeElement.blur()
    submitForm()
  }

  const selector = props.documentTypes.length > 1 ? (
    <select name="document-type" defaultValue={documentType} onChange={evt => onDocumentTypeChange(evt)}>
      { props.documentTypes.map(type => 
        <option key={type}>{type}</option>
      )}
    </select>
  ) : null

  return (
    <View className={styles.root}>
      <Header 
        title={props.msg}
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />
      <Form className={styles.content}>
        { selector }
        <InputField 
          type="text"
          label={documentType}
          name={documentType}
          onChange={evt => applyMask(evt)}
          keyboardType={documentType === 'CPF' ? 'numeric' : 'text'}
          value={value}
          error={error}
          onEnterKeyPress={handleEnterKey}
        />
      </Form>
      <Footer 
        onBack={() => props.back()}
        onNext={() => submitForm()}
        disabled={!value || value === ''} 
      />
    </View>
  )
}

export default IdentificationStep